/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyDetailsDto } from './CompanyDetailsDto';
import type { EngineOilTestDetail } from './EngineOilTestDetail';
import type { FileMetadataDto } from './FileMetadataDto';
export type EngineOilTestDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    customerDetails?: CompanyDetailsDto;
    engineNumber?: string;
    testNumber?: string;
    testBench?: string;
    programTestBench?: string;
    oilDesignation?: string;
    saeClass?: string;
    fuel?: string;
    testEndDate?: string;
    engineType?: string;
    readonly engineTypeName?: string;
    letterNumber: string;
    letterCreatedDate?: string;
    letterSentDate?: string;
    letterReleased?: boolean;
    invoiceCreatedDate?: string;
    invoiceDate?: string;
    invoicePaidDate?: string;
    invoiceNumber?: string;
    invoiceAmount?: string;
    testRestrictions?: string;
    testRun?: EngineOilTestDto.testRun;
    testBenchResult?: string;
    passedSheets?: Array<string>;
    decisionDate?: string;
    receiptOfPartsDate?: string;
    receiptOfLetterDate?: string;
    invoiceReleased?: boolean;
    readonly testAreaId?: string;
    testGroupId?: string;
    testDetail?: EngineOilTestDetail;
    readonly letterFileMetaData?: FileMetadataDto;
    readonly invoiceFileMetaData?: FileMetadataDto;
};
export namespace EngineOilTestDto {
    export enum testRun {
        FIRST_RUN = 'FIRST_RUN',
        SECOND_RUN = 'SECOND_RUN',
        THIRD_RUN = 'THIRD_RUN',
        NO_RUN = 'NO_RUN',
    }
}

